<template>
    <div>
        <div class="offcanvas offcanvas-start" style="width:100%" tabindex="-1" id="mySidebar"
            aria-labelledby="mySidebarLabel"
            :style="'background: linear-gradient(to bottom, hsl(224 67.9% 11%) 60%, hsl(224 50% 5%) 80%, #000 100%);'">
            <div class="offcanvas-header" :style="Skin.side_bar.header_text">
                <div>
                    <language-selector v-bind:skin="Skin" v-bind:language="language" />
                </div>
                <button id="closeSideBar" type="button" class="btn text-reset" data-bs-dismiss="offcanvas" aria-label="Close">
                    <span style="color:white;font-size:large"><i class="fas fa-times"></i></span>
                </button>
            </div>
            <div class="offcanvas-body p-0">
                <div class="tab-content" id="pills-tabContent">
                    <div style="display: flex; flex-direction: column; gap: 1.5rem !important;"
                        class="tab-pane fade p-2 show active" id="pills-navegacion-tab" role="tabpanel"
                        aria-labelledby="pills-navegacion">
                        <div v-for="(item,index) in filteredCategories" :key="index" @click="change_view(index)" style="padding: .5rem;">
                            <div style="display: flex; gap: 8px;align-items: center;">
                                <div :style="Skin.side_bar.navigation_text" style="width:25px;height:25px">
                                    <img :src="item.icon" style="width:100%;height:100%">
                                </div>
                                &nbsp;<span :style="Skin.side_bar.navigation_text">{{ translate(item.name) }}</span>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import languageSelector from './language.vue';
export default {
    name: 'Sidebar',
    components: {
        languageSelector
    },
    props: ['Skin', 'translation', 'language'],
    data() {
        return {
            booking_code: '',
        }
    },
    computed: {
        filteredCategories() {
      return this.$props.Skin.categories.filter(category => category.active);
    },
        favoritos() {
            return this.$store.getters['live/getFavorites'];
        },
        sports() {
            return this.$store.getters['live/getSports'];
        },
        selected_skin() {
            return this.$store.getters['getCurrentSkin'];
        },
        user() {
            return this.$store.getters['getUserData'];
        },
        nav_activeCss() {
            return {
                '--bar': this.$props.Skin.side_bar.nav_active_bar,
                '--text': this.$props.Skin.side_bar.nav_active_text,
            }
        },
    },
    methods: {
        active: function (id) {
            let items = document.getElementsByClassName("item-menu");
            [...items].forEach(item => {
                item.classList.remove('nav_active1');
                item.classList.remove('active');
            });
            document.getElementById(id).classList.add('nav_active1');
            document.getElementById(id).classList.add('active');
        },
        check_booking() {
            if (this.booking_code != '') {
                this.$store.dispatch('getBooking', this.booking_code);
            }
            else {
                this.alert.message = this.translate('Ingresa un código de reserva válido');
                this.alert.type = 'danger';
                this.alert.active = true;
                setTimeout(this.alert_off, 5000);
            }
        },
        change_view(view) {
            document.getElementById('closeSideBar').click();
            this.$store.dispatch("changeView", view);
        },
        login() {
            document.getElementById('closeSideBar').click();
            document.getElementById('login_btn').click();
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav_active1 {
    color: var(--text);
    border-bottom: var(--bar);
}
.icon_casino {
    background-image: url(https://sports.jcasino.live/altenar/img/casino.b69021d3.svg);
}
.offcanvas-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem !important;
}
</style>